<!--
 * @Description: 
 * @Date: 2019-09-19 10:34:18
 -->
<template>
  <el-checkbox
    class="check"
    :true-label="1"
    :false-label="0"
    v-bind="$attrs"
    @input="change($event)"
  >
    乙方可调1
  </el-checkbox>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    change(val) {
      this.$emit('input', val);
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
